import { ApexOptions } from "apexcharts";
import { ScoreData } from "entities";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Header, Segment, Container } from "semantic-ui-react";
import { Labels } from "utils/constants";

interface PieChartProps {
  data: ScoreData[];
  title?: boolean;
  width?: number;
  labelSize?: string;
  legendSize?: string;
}
const PieChart = ({
  data,
  title = true,
  width = 500,
  labelSize = "18px",
  legendSize = "18px",
}: PieChartProps) => {
  const [series, setSeries] = useState([44, 55, 13, 43]);

  const options: ApexOptions = {
    chart: {
      type: "pie",
      stacked: true,
      toolbar: {
        show: true,
      },
    },
    labels: Labels,
    tooltip: {
      fillSeriesColor: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -10,
        },
      },
    },
    dataLabels: {
      style: {
        fontSize: labelSize,
      },
    },
    colors: ["#19ff19", "#ffff00", "#ffa500", "#ff0000"],
    legend: {
      horizontalAlign: "center",
      floating: false,
      fontSize: legendSize,
      fontFamily: "Helvetica, Arial",
      fontWeight: 400,
      offsetY: 30,
      markers: {
        width: 15,
        height: 15,
        strokeWidth: 0,
        radius: 15,
        offsetX: -5,
      },
      itemMargin: {
        horizontal: 3,
        vertical: 9,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300,
            height: 500,
          },
          legend: {
            position: "bottom",
            horizontalAlign: "left",
            floating: false,
            offsetY: 0,
            markers: {
              width: 15,
              height: 15,
              strokeWidth: 0,
              radius: 15,
              offsetX: -5,
            },
            itemMargin: {
              horizontal: 9,
              vertical: 9,
            },
          },
        },
      },
    ],
  };

  useEffect(() => {
    setSeries(
      data.reduce(
        (acc, curr) => {
          acc[0] += curr.score1;
          acc[1] += curr.score2;
          acc[2] += curr.score3;
          acc[3] += curr.score4;
          return acc;
        },
        [0, 0, 0, 0]
      )
    );
  }, [data]);

  return (
    <Segment id="piechart">
      {title && <Header as="h3">Poucentage des réponses</Header>}
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "0 !important",
        }}
      >
        <Chart
          options={options}
          series={series}
          type="pie"
          width={width}
          style={{ margin: "auto" }}
        />
      </Container>
    </Segment>
  );
};

export { PieChart };
